// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 143) return "app.css";
	// return url for filenames based on template
	return "" + ({"175":"PrototypeViewer","551":"static-ui"}[chunkId] || chunkId) + ".chunk.css";
};